import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from './tokens'
import Reveal from './Reveal'

// Design (new-design/Home-New UI SP-Website.png): a plain centered
// heading + subtext block on the light page background — NO blue band,
// NO CTA pill. Two-tone heading (dark ink + brand-blue "SHIPPOP
// BUSINESS") and a two-line subtext whose first line is brand blue and
// second line is dark ink. Sits directly above the video card.
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0 40px',
    background: T.color.canvas,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '44px 0 24px',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 600,
    color: T.color.ink,
    margin: '0 0 16px',
    '& span': {
      color: T.color.brand,
      fontWeight: 700,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  subtitle: {
    fontFamily: T.font.body,
    fontSize: 18,
    color: T.color.ink,
    margin: 0,
    maxWidth: 640,
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 1.6,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
}))

const ShippopBusinessNew = () => {
  const classes = useStyles()
  const { t } = useTranslation('home')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            <span>SHIPPOP BUSINESS</span> {t('shippopBusiness.headingAfter')}
          </h2>
          <p className={classes.subtitle}>
            {t('shippopBusiness.subtitleRest')}
          </p>
        </Reveal>
      </Container>
    </section>
  )
}

export default ShippopBusinessNew
